import { useQuery } from '@apollo/react-hooks';

import { EditorLabelsQuery } from './EditorLabelsQuery.graphql';
import { PREDEFINED_BLUEPRINT_TYPES_TITLES } from './constants';

export const getBlueprintType = (labels) => {
	for (const label of labels) {
		const value = PREDEFINED_BLUEPRINT_TYPES_TITLES[label];
		if (value !== undefined) return label;
	}

	return '';
};

export const getBlueprintFromLabels = (data) => {
	const labels = data?.content?.nodes[0]?.labels?.nodes?.map((x) => x.name) ?? [];
	return getBlueprintType(labels);
};

export const useBlueprintType = (contentId: string, skip: boolean = false) => {
	const { data, loading, error } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		EditorLabelsQuery,
		{
			skip,
			variables: { contentId },
		},
	);

	if (loading || error) {
		return '';
	}

	return getBlueprintFromLabels(data);
};
